<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  
  <div class="container start-page">
    <!-- <i class="nh-table-mobile d-lg-none d-md-block arrow left" (click)="displayNextSection('contactInfo')"></i>
    <i class="nh-table-mobile d-lg-none d-md-block arrow right" (click)="displayNextSection('contactInfo')"></i> -->
    <p *ngIf="isRenewBenefits" class="mt-3">{{'RMB_STARTSCREEN_TEXT_1' | globalTranslate}}</p>
    <h1 *ngIf="isRenewBenefits" class="section-header mt-4">{{'RMB_STARTSCREEN_TEXT_2' | globalTranslate}}</h1>
    <hr />
    <div class="d-none d-lg-block d-md-block"  [formGroup]="getControl('extras.helpers')">
    <p *ngIf="isRenewBenefits" class="pb-4" [innerHTML]="'RMB_STARTSCREEN_TEXT_3' | globalTranslate"></p>
      <!--Head of Household-->
      <div class="pb-4">
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['hoh']"
            (expandedChange)="onExpand('hoh', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="ps-2 mat-cell-panel-header">
                  <div class="d-flex">
                    <img class="col-auto icon" aria-hidden="true" src="assets/images/Report changes/Contact Info.svg">
                    <div class="sub_header">
                      <span class="mat-cell title" id="hoh-label"><span class="text-danger" aria-hidden="true">*</span>{{'HOH' | globalTranslate}}</span>
                      <ng-container *ngIf="expandedPanels['hoh']">
                        <div class="radio-buttons-container">
                          <mat-radio-group style="flex-direction: unset" class="smallRadio" (click)="toggleValue('hoh', $event)" formControlName="hoh" aria-label="Head of Household" [attr.aria-required]="true">
                            <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                            <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <p class="mat-cell"
                    [ngClass]="{'panel_sub_text': expandedPanels['hoh'], 'pad_lt': !expandedPanels['hoh']}">
                    {{'RMB_STARTSCREEN_TEXT_4' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="sub_content">
              <p class="sub_text">
                <span [innerHTML]="'RMB_STARTSCREEN_TEXT_5' | globalTranslate"></span><b>&nbsp;{{'HOH' | globalTranslate}}.</b>
              </p>
            </div>
            <div class="pt-3 pb-3">
              <table class="table w-100 table-striped">
                <thead>
                  <tr>
                    <th style="width:23%" scope="col">{{'HOH_NAME' | globalTranslate}}</th>
                    <th style="width:20%" scope="col">{{'HOME_ADDRESS' | globalTranslate}}</th>
                    <th style="width:20%" scope="col">{{'MAILING_ADDRESS_RMB' | globalTranslate}}</th>
                    <th style="width:20%" scope="col">{{'PHONE_NUMBER_WITHDRAWAL_1' | globalTranslate}}</th>
                    <th style="width:17%"scope="col">{{'ASSISTING_PERSON' | globalTranslate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of hohInfoRows; index as i; last as isLast">
                    <td style="width:20%">
                      {{ row.headOfHousehold }}
                    </td>
                    <td style="width:20%">
                      <span *ngIf="row.homeAddressLine1">{{ row.homeAddressLine1 }},<br><span *ngIf="row.homeAddressLine2"> {{row.homeAddressLine2}},<br></span> {{row.homeAddressCity}},<br>{{row.homeAddressState}}, {{row.homeAddressZip}} <span *ngIf="row.sahMailId"><br>SAH ID: {{row.sahMailId}}</span></span>
                    </td>
                    <td style="width:20%">
                      <span *ngIf="row.sahMailId && row.homeAddressLine1">{{ row.homeAddressLine1 }},<br><span *ngIf="row.homeAddressLine2"> {{row.homeAddressLine2}},<br></span> {{row.homeAddressCity}},<br>{{row.homeAddressState}}, {{row.homeAddressZip}} <span *ngIf="row.sahMailId"><br>SAH ID: {{row.sahMailId}}</span></span>
                      <span *ngIf="!row.sahMailId"><span *ngIf="row.mailingAddressLine1">{{ row.mailingAddressLine1 }},<br><span *ngIf="row.mailingAddressLine2"> {{row.mailingAddressLine2}},<br></span> {{row.mailingAddressCity}},<br>{{row.mailingAddressState}}, {{row.mailingAddressZip}}</span></span>
                    </td>
                    <td style="width:20%">
                      <span *ngIf="row.home || row.cell || row.extenssion || row.message">
                        <span *ngIf="row.home">{{'(Home)' | globalTranslate}} <br>{{ row.home | phone}}</span> <span *ngIf="row.cell"><br *ngIf="row.home">{{'(Cell)' | globalTranslate}} <br>{{row.cell | phone}}</span>  <span *ngIf="row.message"><br *ngIf="row.home || row.cell">{{'(Work)' | globalTranslate}} <br>{{row.message | phone}}</span> <span *ngIf="row.extenssion"><br *ngIf="row.home || row.cell || row.message">{{'Ext' | globalTranslate}}. {{row.extenssion}}</span>
                    </span>
                    <span *ngIf="(row.home === null) && (row.cell === null) && (row.extenssion === null) && (row.message === null)">{{'Not Answered' | globalTranslate}}</span>
                    </td>
                    <td style="width:20%">
                      {{ row.assistingPerson | globalTranslate}} <br *ngIf="row.assistingRelation">{{row.assistingRelation | globalTranslate}} <span *ngIf="row.assistingOrganization">- <br>{{row.assistingOrganization | globalTranslate}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <!--People in your Home-->
      <div class="pb-4">
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['peopleInYourHome']"
            (expandedChange)="onExpand('peopleInYourHome', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="ps-2 mat-cell-panel-header">
                  <div class="d-flex">
                    <img class="col-auto icon" aria-hidden="true"
                      src="assets/images/Report changes/Household Members.svg" />
                    <div class="sub_header">
                      <span class="mat-cell title" id="peopleInYourHome-label"><span class="text-danger" aria-hidden="true">*</span>{{'People in Your Home' | globalTranslate}}</span>
                      <ng-container *ngIf="expandedPanels['peopleInYourHome']">
                        <div class="radio-buttons-container">
                          <mat-radio-group style="flex-direction: unset" class="smallRadio" (click)="toggleValue('peopleInYourHome', $event)" formControlName="peopleInYourHome" aria-label="People in Your Home" [attr.aria-required]="true">
                            <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                            <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </ng-container>
    
                    </div>
                  </div>
                  <p class="mat-cell"
                    [ngClass]="{'panel_sub_text': expandedPanels['peopleInYourHome'], 'pad_lt': !expandedPanels['peopleInYourHome']}">
                    {{'RMB_STARTSCREEN_TEXT_14' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description aria-hidden="true"></mat-panel-description>
            </mat-expansion-panel-header>
            <div class="sub_content">
              <p class="sub_text" [innerHTML]="'RMB_STARTSCREEN_TEXT_6' | globalTranslate"></p>
            </div>
            <div class="pt-3 pb-3">
              <table class="table w-100 table-striped">
                <thead>
                  <tr>
                    <th style="width:25%" scope="col">{{'Name' | globalTranslate}}</th>
                    <th style="width:30%" scope="col">{{'Citizenship/Residency' | globalTranslate}}</th>
                    <th style="width:25%" scope="col">{{'LIVING_ARRANGEMENT' | globalTranslate}}</th>
                    <th style="width:20%" scope="col">{{'Additional Details' | globalTranslate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of peopleInfoRows; index as i; last as isLast">
                    <td style="width:25%">
                      {{ row.member }} <br> {{row.ssn}}
                    </td>
                    <td style="width:30%">
                      {{ row.citizenship | globalTranslate }} <br> {{row.tnResident | globalTranslate}}
                    </td>
                    <td style="width:25%">
                      {{ row.livingArrangement | globalTranslate }}
                    </td>
                    <td style="width:20%">
                      {{ row.additionalDetails | globalTranslate}} <span *ngIf="row.dueDate !== null"><br *ngIf="row.dueDate !== null"> {{'Due Date' | globalTranslate}}: {{row.dueDate | date: 'MM/dd/yyyy'}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <!--Household information-->
      <div class="pb-4">
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['householdInfo']"
            (expandedChange)="onExpand('householdInfo', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="ps-2 mat-cell-panel-header">
                  <div class="d-flex">
                    <img class="col-auto icon" aria-hidden="true" src="assets/images/Report changes/Household Info.png" />
                    <div class="sub_header">
                      <span class="mat-cell title" id="householdInfo-label"><span class="text-danger" aria-hidden="true">*</span>{{'RMB_STARTSCREEN_TEXT_8' | globalTranslate}}</span>
                      <ng-container *ngIf="expandedPanels['householdInfo']">
                        <div class="radio-buttons-container">
                          <mat-radio-group style="flex-direction: unset" class="smallRadio" (click)="toggleValue('householdInfo', $event)" formControlName="householdInfo" aria-label="Household Information" [attr.aria-required]="true">
                            <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                            <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <p class="mat-cell"
                    [ngClass]="{'panel_sub_text': expandedPanels['householdInfo'], 'pad_lt': !expandedPanels['householdInfo']}">
                    {{'RMB_STARTSCREEN_TEXT_15' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description aria-hidden="true"></mat-panel-description>
            </mat-expansion-panel-header>
            <div class="sub_content">
              <p class="sub_text">
                <span [innerHTML]="'RMB_STARTSCREEN_TEXT_30' | globalTranslate"></span>
              </p>
            </div>
            <!-- Relationship Information -->
            <div *ngIf="relationshipRows.length" class="pt-3 pb-3">
              <p class="text-color"><strong>{{'RELATIONSHIP' | globalTranslate}}</strong></p>
              <table *ngIf="relationshipRows.length" class="table w-100 table-striped">
                <thead>
                  <tr>
                    <th scope="col" style="width:70%">{{'Relationship' | globalTranslate}}</th>
                    <th scope="col" style="width:30%" aria-labelledby="primaryCaregiverLabel">
                      {{'Primary Caregiver' | globalTranslate}}
                      <nh-popover [iconMode]="'transparent'" [content]="'PrimaryCareGiver_PopUp' | globalTranslate" class="ps-1"></nh-popover>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let row of relationIndivLeverArray; index as i; last as isLast">
                    <tr *ngFor="let indiv of row">
                      <td style="width:70%">{{indiv.sourceName}} {{ indiv.relation | globalTranslate }} {{indiv.refIndivName}}</td>
                      <td style="width:30%">{{indiv.primaryCareGiver | globalTranslate}}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
              <!-- <p *ngIf="!relationshipRows.length" class="mb-5" [innerHTML]="'RMB_RelationData' | globalTranslate">{{'RMB_RelationData' | globalTranslate }}</p> -->
            </div>
            <!-- School and Employment Information -->
            <div *ngIf="displaySchoolAndEmployment" class="pt-3 pb-3">
              <p class="text-color"><strong>{{'SCHOOL' | globalTranslate}}&nbsp;{{'AND_TEXT' | globalTranslate}}&nbsp;{{'EMPLOYMENT' |
                  globalTranslate}}</strong></p>
                  <table *ngIf="schoolAndEmploymentRows.length" class="table w-100 table-striped">
                    <thead>
                      <tr>
                        <th style="width:25%;" scope="col">{{'Name' | globalTranslate}}</th>
                        <th style="width:40%;" scope="col">{{'Under age 22 and enrolled in school?' | globalTranslate}}</th>
                        <th style="width:35%;" scope="col">{{'Working full time' | globalTranslate}} </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of schoolAndEmploymentRows; index as i; last as isLast">
                        <td style="width:25%">
                           {{ row.name }}
                        </td>
                        <td style="width:40%">
                          {{ row.education | globalTranslate }}
                        </td>
                        <td style="width:35%">
                          {{ row.isWorkingFullTime | globalTranslate }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p *ngIf="!schoolAndEmploymentRows.length" class="mb-5" [innerHTML]="'RMB_SchoolEmpoyment' | globalTranslate"></p>
            </div>
            <!-- Other Health Insurance Information -->
            <div class="pt-3 pb-3">
              <p class="text-color"><strong>{{'OTHER_COVERAGE' | globalTranslate}}</strong></p>
              <table *ngIf="otherHealthInsuranceRows.length" class="table w-100 table-striped">
                <thead>
                  <tr>
                    <th scope="col" style="width:20%">{{'Policy Holder Name' | globalTranslate}}</th>
                    <th scope="col" style="width:20%">{{'Who is Covered' | globalTranslate }}</th>
                    <th scope="col" style="width:20%">{{'Coverage Type & Start Date' | globalTranslate }}</th>
                    <th scope="col" style="width:20%">{{'Policy Number/ Group Number' | globalTranslate }}</th>
                    <th scope="col" style="width:20%">{{'Premium Amount' | globalTranslate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of otherHealthInsuranceRows; index as i; last as isLast">
                    <td style="width:20%">
                      {{ row.policyHolderName }}
                    </td>
                    <td style="width:20%">
                      <ul class="no-bullets"><li *ngFor="let owner of row.whoIsCovered">{{owner.name}}</li></ul>
                    </td>
                    <td style="width:20%">
                      {{ row.coverageType | globalTranslate }} <span *ngIf="row.companyName !== null">- {{row.companyName}}</span><br><span *ngIf="row.coverageSTartDate !== null">{{'Starting ' | globalTranslate}}</span> {{row.coverageSTartDate | date: 'MM/dd/yyyy'}}
                    </td>
                    <td style="width:20%">
                      <span *ngIf="row.policyNum">{{'Policy Number' | globalTranslate}}: {{ row.policyNum | globalTranslate }} <br></span>
                      <span *ngIf="row.groupNum">{{'Group Number' | globalTranslate}}: {{ row.groupNum | globalTranslate }}</span>
                    </td>
                    <td style="width:20%">
                      {{ row.premiumAmount | globalTranslate }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <p *ngIf="!otherHealthInsuranceRows.length" class="mb-5" [innerHTML]="'RMB_OtherHealth' | globalTranslate"></p>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <!--Tax Information-->
      <div class="pb-4">
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['taxInformation']"
            (expandedChange)="onExpand('taxInformation', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="ps-2 mat-cell-panel-header">
                  <div class="d-flex">
                    <img class="col-auto icon" aria-hidden="true" src="assets/images/Report changes/TaxInformation.svg" />
                    <div class="sub_header">
                      <span class="mat-cell title" id="taxInformation-label"><span class="text-danger" aria-hidden="true">*</span>{{'RMB_STARTSCREEN_TEXT_9' | globalTranslate}}</span>
                      <ng-container *ngIf="expandedPanels['taxInformation']">
                        <div class="radio-buttons-container">
                          <mat-radio-group style="flex-direction: unset" class="smallRadio" (click)="toggleValue('taxInformation', $event)" formControlName="taxInformation" aria-label="Tax Information" [attr.aria-required]="true">
                            <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                            <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <p class="mat-cell"
                    [ngClass]="{'panel_sub_text': expandedPanels['taxInformation'], 'pad_lt': !expandedPanels['taxInformation']}">
                    {{'RMB_STARTSCREEN_TEXT_16' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description aria-hidden="true"></mat-panel-description>
            </mat-expansion-panel-header>
            <div class="sub_content">
              <p class="sub_text">
                <span [innerHTML]="'RMB_STARTSCREEN_TEXT_29' | globalTranslate"></span>
              </p>
            </div>
            <!-- Tax Filer Inside Household -->
            <div class="pt-3 pb-3">
              <p class="text-color"><strong>{{'RMB_TAX_INSIDE' | globalTranslate}}</strong></p>
              <table *ngIf="taxRows.length && taxRows[0]?.name" class="table w-100 table-striped">
                <thead>
                  <tr>
                    <th scope="col" style="width:20%">{{'Tax Filer' | globalTranslate}}</th>
                    <th scope="col" style="width:20%">{{'Filing Jointly With' | globalTranslate}}</th>
                    <th scope="col" style="width:20%">{{'Tax Dependents' | globalTranslate}}</th>
                    <th scope="col" style="width:20%">{{'RMB_TAX_DEDUCTIONS' | globalTranslate}}</th>
                    <th scope="col" style="width:20%">{{'Outside Household Dependents' | globalTranslate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of taxRows">
                    <td style="width:20%">
                      {{ row.name | globalTranslate }}
                    </td>
                    <td style="width:20%">
                      {{ row.filingJointly | globalTranslate }}
                    </td>
                    <td style="width:20%">
                      <ul *ngIf="row.dependents?.length" class="no-bullets"><li *ngFor="let dependent of row.dependents">{{dependent.name}}</li></ul>
                      <span *ngIf="!row.dependents?.length">{{'No' | globalTranslate}}</span>
                    </td>
                    <td style="width:20%">
                      <ul *ngIf="row.deductions?.length" class="no-bullets"><li *ngFor="let deduction of row.deductions; last as isLast">
                        <span *ngIf="deduction.type">{{deduction.type | globalTranslate}}</span><span *ngIf="deduction.amount"><br>{{deduction.amount | globalTranslate}} {{deduction.frequency | globalTranslate}}</span><span *ngIf="row.deductions.length > 1 && !isLast">,</span></li></ul>
                      <span *ngIf="!row.deductions?.length">{{'No' | globalTranslate}}</span>
                    </td>
                    <td style="width:20%">
                      <ul *ngIf="row.outOfHouseDependents?.length" class="no-bullets"><li *ngFor="let outOfHouse of row.outOfHouseDependents">
                        <span *ngIf="outOfHouse.name">{{outOfHouse.name | globalTranslate}}</span></li></ul>
                        <span *ngIf="!row.outOfHouseDependents?.length">{{'No' | globalTranslate}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p *ngIf="(taxRows.length && !taxRows[0].name) || (!taxRows.length)" class="mb-5" [innerHTML]="'RMB_TAX_FILER_INSIDE' | globalTranslate"></p>
            </div>
            <!-- Tax Filer Ouside Household -->
            <div class="pt-3 pb-3">
              <p class="text-color"><strong>{{'RMB_TAX_OUTSIDE' | globalTranslate}}</strong></p>
              <table *ngIf="taxOutsideRows?.length > 0" class="table w-100 table-striped" >
                <thead>
                  <tr>
                    <th scope="col" style="width:25%">{{'Tax Filer' | globalTranslate}}</th>
                    <th scope="col" style="width:40%">{{'RMB_OUTSIDE_STATIC1' | globalTranslate}}</th>
                    <th scope="col" style="width:35%">{{'RMB_OUTSIDE_STATIC2' | globalTranslate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of taxOutsideRows">
                    <td style="width:25%">
                      {{ row.outOfHouseFiler | globalTranslate }}
                    </td>
                    <td style="width:40%">
                      {{ row.claimedDependent | globalTranslate }}
                    </td>
                    <td style="width:35%">
                      {{ row.relationshipToOutsideTaxFiler | globalTranslate }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <p *ngIf="taxOutsideRows?.length === 0" class="mb-5" [innerHTML]="'RMB_TAX_FILER_OUTSIDE' | globalTranslate"></p>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <!--Income and Employment-->
      <div class="pb-4">
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['incomeEmployment']"
            (expandedChange)="onExpand('incomeEmployment', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="ps-2 mat-cell-panel-header">
                  <div class="d-flex">
                    <img class="col-auto icon" aria-hidden="true" src="assets/images/Report changes/Income&Employment.svg" />
                    <div class="sub_header">
                      <span class="mat-cell title" id="incomeEmployment-label"><span class="text-danger" aria-hidden="true">*</span>{{'RMB_STARTSCREEN_TEXT_10' | globalTranslate}}</span>
                      <ng-container *ngIf="expandedPanels['incomeEmployment']">
                        <div class="radio-buttons-container">
                          <mat-radio-group style="flex-direction: unset" class="smallRadio" (click)="toggleValue('incomeEmployment', $event)" formControlName="incomeEmployment" aria-label="Income and Employment" [attr.aria-required]="true">
                            <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                            <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <p class="mat-cell"
                    [ngClass]="{'panel_sub_text': expandedPanels['incomeEmployment'], 'pad_lt': !expandedPanels['incomeEmployment']}">
                    {{'RMB_STARTSCREEN_TEXT_17' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description aria-hidden="true"></mat-panel-description>
            </mat-expansion-panel-header>
            <div class="sub_content">
              <p class="sub_text">
                <span [innerHTML]="'RMB_STARTSCREEN_TEXT_27' | globalTranslate"></span>
              </p>
            </div>
            <div class="pt-3 pb-3">
              <p class="text-color"><strong>{{'EMPLOYMENT_INCOME' | globalTranslate}}</strong></p>
              <table *ngIf="employmentIncomeRows.length" class="table w-100 table-striped">
                <thead>
                  <tr>
                    <th scope="col" style="width:25%">{{'Name' | globalTranslate}}</th>
                    <th scope="col" style="width:25%">{{'EMPLOYMENT_STATIC_TEXT5' | globalTranslate}}</th>
                    <th scope="col" style="width:25%">{{'Start Date' | globalTranslate}}</th>
                    <th scope="col" style="width:25%">{{'Amount & How Often' | globalTranslate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of employmentIncomeRows; index as i; last as isLast">
                    <td style="width:25%">
                      {{ row.name | globalTranslate }}
                    </td>
                    <td style="width:25%">
                      {{ row.employer | globalTranslate }}
                    </td>
                    <td style="width:25%">
                      <span *ngIf="row.startDate">{{ row.startDate | date: 'MM/dd/yyyy' }}</span>
                      <span *ngIf="!row.startDate">{{ 'Not Answered' | globalTranslate}}</span>
                    </td>
                    <td style="width:25%">
                      {{ row.wage | globalTranslate }} {{row.frequency | globalTranslate}}
                    </td>
                  </tr>
                </tbody>
              </table>
              <p *ngIf="!employmentIncomeRows.length" class="mb-5" [innerHTML]="'RMB_EMPLOYMENT' | globalTranslate"></p>
            </div>
            <div class="pt-3 pb-3">
              <p class="text-color"><strong>{{'SELF_EMPLOYMENT_INCOME' | globalTranslate}}</strong></p>
              <table *ngIf="selfEmploymentIncomeRows.length" class="table w-100 table-striped">
                <thead>
                  <tr>
                    <th scope="col" style="width:20%">{{'Name' | globalTranslate}}</th>
                    <th scope="col" style="width:20%">{{'Business Type' | globalTranslate}}</th>
                    <th scope="col" style="width:20%">{{'Net Income' | globalTranslate}}</th>
                    <th scope="col" style="width:20%">{{'SELF_EMPLOYMENT_STATIC_TEXT4' | globalTranslate}}</th>
                    <th scope="col" style="width:20%">{{'CO-OWENERS_HEADER1' | globalTranslate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of selfEmploymentIncomeRows; index as i; last as isLast">
                    <td style="width:20%">
                      {{ row.member }}
                    </td>
                    <td style="width:20%">
                      {{ row.bussinessType | globalTranslate }}
                    </td>
                    <td style="width:20%">
                      {{ row.netIncome | globalTranslate }}
                    </td>
                    <td style="width:20%">
                      {{ row.bussinessName }}
                    </td>
                    <td style="width:20%"><ul *ngIf="row.coOwner?.length" class="no-bullets"><li *ngFor="let owner of row.coOwner">{{owner.namePercent}}</li></ul>
                        <span *ngIf="!row.coOwner?.length">{{'No' | globalTranslate}}</span></td>
                  </tr>
                </tbody>
              </table>
              <p *ngIf="!selfEmploymentIncomeRows.length" class="mb-5" [innerHTML]="'RMB_SELF_EMPLOYMENT' | globalTranslate"></p>
            </div>
            <div class="pt-3 pb-3">
              <p class="text-color"><strong>{{'OTHER_INCOME' | globalTranslate}}</strong></p>
              <table *ngIf="otherIncomeRows.length" class="table w-100 table-striped">
                <thead>
                  <tr>
                    <th scope="col" style="width:25%">{{'Name' | globalTranslate}}</th>
                    <th scope="col" style="width:25%">{{'Income Type' | globalTranslate}}</th>
                    <th scope="col" style="width:25%">{{'Start Date' | globalTranslate}}</th>
                    <th scope="col" style="width:25%">{{'Amount & How Often' | globalTranslate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of otherIncomeRows; index as i; last as isLast">
                    <td style="width:25%">
                      {{ row.name | globalTranslate }}
                    </td>
                    <td style="width:25%">
                      {{ row.incometype | globalTranslate }}
                    </td>
                    <td style="width:25%">
                      <span *ngIf="row.startDate">{{ row.startDate | date: 'MM/dd/yyyy' }}</span>
                      <span *ngIf="!row.startDate">{{ 'N/A' }}</span>
                    </td>
                    <td style="width:25%">
                      {{ row.wage | globalTranslate }} {{row.frequency | globalTranslate}}
                    </td>
                  </tr>
                </tbody>
              </table>
              <p *ngIf="!otherIncomeRows.length" class="mb-5" [innerHTML]="'RMB_OTHER_INCOME' | globalTranslate"></p>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <!--Other Health Care-->
      <div class="pb-4">
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['otherBenefits']"
            (expandedChange)="onExpand('otherBenefits', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="ps-2 mat-cell-panel-header">
                  <div class="d-flex">
                    <img class="col-auto icon" aria-hidden="true" src="assets/images/Report changes/OtherBenefits.svg" />
                    <div class="sub_header">
                      <span class="mat-cell title">{{'Other Health Care' | globalTranslate}}</span>
                    </div>
                  </div>
                  <p class="mat-cell"
                    [ngClass]="{'panel_sub_text': expandedPanels['otherBenefits'], 'pad_lt': !expandedPanels['otherBenefits']}">
                    {{'RMB_STARTSCREEN_TEXT_18' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description aria-hidden="true"></mat-panel-description>
            </mat-expansion-panel-header>
            <div class="sub_content">
              <p class="sub_text">
                <span [innerHTML]="'RMB_STARTSCREEN_TEXT_31' | globalTranslate"></span>
              </p>
            </div>
            <!-- othe health Care questions -->
            <div class="pt-3 pb-3">
              <p class="text-color"><strong>{{'Other Health Care Questions' | globalTranslate}}</strong></p>
              <table *ngIf="otherBenefitsRows.length" class="table w-100 table-striped">
                <thead>
                  <tr>
                    <th style="width:50%" scope="col">{{'Assistance' | globalTranslate}}</th>
                    <th style="width:20%" aria-hidden="true"></th>
                    <th style="width:30%" scope="col">{{'Response' | globalTranslate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of otherBenefitsRows; index as i; last as isLast">
                    <td style="width:50%">
                      {{ row.key | globalTranslate }}
                    </td>
                    <td style="width:20%" aria-hidden="true"></td>
                    <td style="width:30%">
                      {{ row.value | globalTranslate }}
                    </td>
                </tbody>
              </table>
              <p *ngIf="!otherBenefitsRows.length" class="mb-5" [innerHTML]="'RMB_OTHER_BENEFITS' | globalTranslate"></p>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    <div class="nh-table-mobile d-lg-none" [formGroup]="getControl('extras.helpers')" #carouselContainer>
      <p *ngIf="isRenewBenefits" class="pb-4" [innerHTML]="'RMB_STARTSCREEN_TEXT_32' | globalTranslate"></p>
      <i id="leftarrow" class="leftarrow left" (click)="owlCar.prev()"></i>
      <i id="rightarrow" class="rightarrow right" (click)="owlCar.next()"></i>
      <nh-alert type="warning" [isOpen]="showBanner">
        <div class="row">
          <div class="col-auto icon">
            <img aria-hidden="true" src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg" alt="warning" />
          </div>
          <div class="col message">
            <span [innerHTML]="'RMB_BANNER_MESSAGE' | globalTranslate"></span>
          </div>
        </div>
      </nh-alert>
      <owl-carousel-o [options]="customOptions" #owlCar (translated)="onSlideChange($event)">
        <ng-template class="slide" carouselSlide>
      <!--Mobile browser HOH Information-->
      <div  id="slide1" class="pb-4 slide-content">
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['hoh']" (expandedChange)="onExpand('hoh', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="mat-cell-panel-header">
                  <div class="d-flex pt-3">
                  <img class="col-auto icon" aria-hidden="true" src="assets/images/Report changes/Contact Info.svg">
                  <div class="sub_header">
                    <span class="mat-cell title"><span class="text-danger" aria-hidden="true">*</span>{{'HOH' | globalTranslate}}<span class="sr-only"> required</span></span>
                  </div>
                  </div>
                  <br>
                    <ng-container *ngIf="expandedPanels['hoh']">
                      <div class="radio-buttons-container">
                        <mat-radio-group class="smallRadio" style="flex-direction: unset" (click)="toggleValue('hoh', $event)" formControlName="hoh" aria-label="Head of Household">
                            <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                            <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </ng-container>
                  <br>
                  <p
                    [ngClass]="{'panel_sub_text': expandedPanels['hoh'], 'pad_lt': !expandedPanels['hoh']}">
                    {{'RMB_STARTSCREEN_TEXT_4' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description aria-hidden="true"></mat-panel-description>
            </mat-expansion-panel-header>

            <div class="sub_content pb-4">
              <p class="sub_text">
                <span [innerHTML]="'RMB_STARTSCREEN_TEXT_5' | globalTranslate"></span><b>&nbsp;{{'HOH' | globalTranslate}}.</b>
              </p>
            </div>
            <ng-container >
							<div *ngFor="let row of hohInfoRows; let last = last">
								<div class="table-row mb-3 pb-3 item active" [ngClass]="{'last-row': last}">
									<div class="mobile-table-header">{{'HOH_NAME' | globalTranslate}}</div>
									<hr>
									<div  class="mobile-table-data">{{row.headOfHousehold}}</div>
									<br>
									<div class="mobile-table-header">{{'HOME_ADDRESS' | globalTranslate }}</div>
									<hr>
									<div class="mobile-table-data"><span *ngIf="row.homeAddressLine1">{{ row.homeAddressLine1 | globalTranslate }},<br><span *ngIf="row.homeAddressLine2"> {{row.homeAddressLine2}},<br></span> {{row.homeAddressCity}},<br>{{row.homeAddressState}}, {{row.homeAddressZip}} <span *ngIf="row.sahMailId"><br>SAH ID: {{row.sahMailId}}</span></span></div>
									<br>
									<div class="mobile-table-header">{{'MAILING_ADDRESS_RMB' | globalTranslate }}</div>
                  <hr>
									<div class="mobile-table-data"><span *ngIf="row.sahMailId && row.homeAddressLine1">{{ row.homeAddressLine1 | globalTranslate }},<br><span *ngIf="row.homeAddressLine2"> {{row.homeAddressLine2}},<br></span> {{row.homeAddressCity}},<br>{{row.homeAddressState}}, {{row.homeAddressZip}} <span *ngIf="row.sahMailId"><br>SAH ID: {{row.sahMailId}}</span></span>
                    <span *ngIf="!row.sahMailId"><span *ngIf="row.mailingAddressLine1">{{ row.mailingAddressLine1 | globalTranslate }},<br><span *ngIf="row.mailingAddressLine2"> {{row.mailingAddressLine2}},<br></span> {{row.mailingAddressCity}},<br>{{row.mailingAddressState}}, {{row.mailingAddressZip}}</span></span></div>
                  <br>
									<div class="mobile-table-header">{{'PHONE_NUMBER_WITHDRAWAL_1'| globalTranslate}}</div>
                  <hr>
									<div class="mobile-table-data">
                    <span *ngIf="row.home || row.cell || row.extenssion || row.message">
                      <span *ngIf="row.home">{{'(Home)' | globalTranslate}} <br>{{ row.home | phone}}</span> <span *ngIf="row.cell"><br *ngIf="row.home">{{'(Cell)' | globalTranslate}} <br>{{row.cell | phone}}</span>  <span *ngIf="row.message"><br *ngIf="row.home || row.cell">{{'(Work)' | globalTranslate}} <br>{{row.message | phone}}</span> <span *ngIf="row.extenssion"><br *ngIf="row.home || row.cell || row.message">{{'Ext' | globalTranslate}}. {{row.extenssion}}</span>
                    </span>
                    <span *ngIf="(row.home === null) && (row.cell === null) && (row.extenssion === null) && (row.message === null)">{{'Not Answered' | globalTranslate}}</span>
                  </div>
                    <br>
									<div class="mobile-table-header">{{'ASSISTING_PERSON' | globalTranslate }}</div>
                  <hr>
									<div class="mobile-table-data">{{ row.assistingPerson }} <br *ngIf="row.assistingRelation">{{row.assistingRelation}} <span *ngIf="row.assistingOrganization">- <br>{{row.assistingOrganization}}</span></div>
								</div>
							</div>
						</ng-container>
						<p *ngIf="!hohInfoRows.length" class="mb-5">{{'NO_DATA_TO_DISPLAY' | globalTranslate }}</p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      </ng-template>
      <ng-template class="slide" carouselSlide>
      <!--Mobile browser People In your Home-->
      <div  id="slide2"  class="pb-4 slide-content" >
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['peopleInYourHome']" (expandedChange)="onExpand('peopleInYourHome', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="mat-cell-panel-header">
                  <div class="d-flex pt-3">
                    <img class="col-auto icon" aria-hidden="true"
                      src="assets/images/Report changes/Household Members.svg" />
                    <div class="sub_header">
                      <span class="mat-cell title"><span class="text-danger" aria-hidden="true">*</span>{{'People in Your Home' | globalTranslate}}<span class="sr-only"> required</span></span>  
                    </div>
                  </div>
                  <br>
                  <ng-container *ngIf="expandedPanels['peopleInYourHome']">
                    <div class="radio-buttons-container">
                      <mat-radio-group class="smallRadio" style="flex-direction: unset" (click)="toggleValue('peopleInYourHome', $event)" formControlName="peopleInYourHome" aria-label="People in Your Home">
                        <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                        <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </ng-container>
                  <br>
                  <p class="mat-cell"
                    [ngClass]="{'panel_sub_text': expandedPanels['peopleInYourHome'], 'pad_lt': !expandedPanels['peopleInYourHome']}">
                    {{'RMB_STARTSCREEN_TEXT_14' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description aria-hidden="true"></mat-panel-description>
            </mat-expansion-panel-header>

            <div class="sub_content pb-4">
              <p class="sub_text" [innerHTML]="'RMB_STARTSCREEN_TEXT_6' | globalTranslate"></p>
            </div>
            <ng-container *ngIf="peopleInfoRows.length">
							<div *ngFor="let row of peopleInfoRows; let last = last" [ngClass]="{'data_container': !last}">
								<div class="table-row mb-3 pb-3 item active" [ngClass]="{'last-row': last}">
									<div class="mobile-table-header">{{'Name' | globalTranslate}}</div>
									<hr>
									<div  class="mobile-table-data">{{ row.member }} <br> {{row.ssn}}</div>
									<br>
									<div class="mobile-table-header">{{'Citizenship/Residency' | globalTranslate }}</div>
									<hr>
									<div class="mobile-table-data">{{ row.citizenship | globalTranslate }} <br> {{row.tnResident | globalTranslate}}</div>
									<br>
									<div class="mobile-table-header">{{'LIVING_ARRANGEMENT' | globalTranslate }}</div>
                  <hr>
									<div class="mobile-table-data">{{row.livingArrangement | globalTranslate}}</div>
                  <br>
									<div class="mobile-table-header">{{'Additional Details' | globalTranslate }}</div>
                  <hr>
									<div class="mobile-table-data" [ngClass]="{ 'column_padding': !last}">{{row.additionalDetails | globalTranslate}} <span *ngIf="row.dueDate !== null"><br *ngIf="row.dueDate !== null"> {{'Due Date' | globalTranslate}}: {{row.dueDate | date: 'MM/dd/yyyy'}}</span></div>
								</div>
							</div>
						</ng-container>
						<p *ngIf="!peopleInfoRows.length" class="mb-5">{{'NO_DATA_TO_DISPLAY' | globalTranslate }}</p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      </ng-template>
      <ng-template class="slide" carouselSlide>
      <!--Mobile browser Household information-->
      <div  id="slide3"  class="pb-4 slide-content">
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['householdInfo']" (expandedChange)="onExpand('householdInfo', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="mat-cell-panel-header">
                  <div class="d-flex pt-3">
                    <img class="col-auto icon" aria-hidden="true"
                    src="assets/images/Report changes/Household Info.png" />
                    <div class="sub_header">
                      <span class="mat-cell title"><span class="text-danger" aria-hidden="true">*</span>{{'RMB_STARTSCREEN_TEXT_8' | globalTranslate}}<span class="sr-only"> required</span></span>
                    </div>
                  </div>
                  <br>
                  <ng-container *ngIf="expandedPanels['householdInfo']">
                    <div class="radio-buttons-container">
                      <mat-radio-group class="smallRadio" style="flex-direction: unset" (click)="toggleValue('householdInfo', $event)" formControlName="householdInfo" aria-label="Household Information">
                        <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                        <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </ng-container>
                  <br>
                  <p class="mat-cell"
                    [ngClass]="{'panel_sub_text': expandedPanels['householdInfo'], 'pad_lt': !expandedPanels['householdInfo']}">
                    {{'RMB_STARTSCREEN_TEXT_15' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description aria-hidden="true"></mat-panel-description>
            </mat-expansion-panel-header>

            <div class="sub_content pb-4">
              <p class="sub_text"><span [innerHTML]="'RMB_STARTSCREEN_TEXT_30' | globalTranslate"></span></p>
            </div>
            <ng-container>
              <!-- Relationship Information -->
              <p *ngIf="relationshipRows.length" class="text-color sub_module_header pb-3"><strong>{{'RELATIONSHIP' | globalTranslate}}</strong></p>
              <ng-container *ngIf="relationshipRows.length">
							<div *ngFor="let row of relationshipRows; let last = last" class="data_container">
								<div class="table-row mb-3 pb-3 item active">
									<div class="mobile-table-header">{{'Relationship' | globalTranslate}}</div>
									<hr>
									<div  class="mobile-table-data"> {{row.sourceName}} {{ row.relation | globalTranslate }} {{row.refIndivName}}</div>
									<br>
									<div class="mobile-table-header"><span id="mobilePrimaryCaregiverLabel">{{'Primary Caregiver' | globalTranslate }}</span> <nh-popover [content]="'PrimaryCareGiver_PopUp' | globalTranslate" class="ps-1"></nh-popover></div>
									<hr>
									<div class="mobile-table-data column_padding">{{ row.primaryCareGiver | globalTranslate }}</div>
								</div>
							</div>
            </ng-container>
              <!-- <p *ngIf="!relationshipRows.length" class="mb-5" [innerHTML]="'RMB_RelationData' | globalTranslate"></p> -->
               <!-- School and Employment Information -->
              <div *ngIf="displaySchoolAndEmployment">
                <p class="text-color sub_module_header pb-3"><strong>{{'SCHOOL_AND_EMPLOYMENT' | globalTranslate}}</strong></p>
                <ng-container *ngIf="schoolAndEmploymentRows.length">
                  <div *ngFor="let row of schoolAndEmploymentRows; let last = last" class="data_container">
                    <div class="table-row mb-3 pb-3 item active">
                      <div class="mobile-table-header">{{'Name' | globalTranslate}}</div>
                      <hr>
                      <div class="mobile-table-data"> {{ row.name }}</div>
                      <br>
                      <div class="mobile-table-header">{{'Under age 22 and enrolled in school?' | globalTranslate }}</div>
                      <hr>
                      <div class="mobile-table-data">{{ row.education | globalTranslate }}</div>
                      <br>
                      <div class="mobile-table-header">{{'Working full time' | globalTranslate }}</div>
                      <hr>
                      <div class="mobile-table-data column_padding">{{ row.isWorkingFullTime | globalTranslate }}</div>
                    </div>
                  </div>
                </ng-container>
                <p *ngIf="!schoolAndEmploymentRows.length" class="mb-5" [innerHTML]="'RMB_SchoolEmpoyment' | globalTranslate"></p>
              </div>
               <!-- Other Health Insurance Information -->
              <p class="text-color sub_module_header pb-3"><strong>{{'OTHER_COVERAGE' | globalTranslate}}</strong></p>
              <ng-container *ngIf="otherHealthInsuranceRows.length">
              <div *ngFor="let row of otherHealthInsuranceRows; let last = last" [ngClass]="{'data_container': !last}">
								<div class="table-row mb-3 pb-3 item active"  [ngClass]="{'last-row': last}">
									<div class="mobile-table-header">{{'Policy Holder Name' | globalTranslate}}</div>
									<hr>
									<div  class="mobile-table-data"> {{ row.policyHolderName }}</div>
									<br>
									<div class="mobile-table-header">{{'Who is Covered' | globalTranslate }}</div>
									<hr>
									<div class="mobile-table-data"><ul class="no-bullets"><li *ngFor="let owner of row.whoIsCovered">{{owner.name}}</li></ul></div>
                  <br>
                  <div class="mobile-table-header">{{'Coverage Type & Start Date' | globalTranslate }}</div>
									<hr>
									<div class="mobile-table-data">{{ row.coverageType | globalTranslate }} <br><span *ngIf="row.coverageSTartDate">{{'Starting ' | globalTranslate}}</span> {{row.coverageSTartDate | date: 'MM/dd/yyyy'}}</div>
                  <br>
                  <div class="mobile-table-header">{{'Policy Number/Group Number' | globalTranslate }}</div>
									<hr>
									<div class="mobile-table-data" *ngIf="row.policyNum">{{'Policy Number' | globalTranslate}}: {{ row.policyNum | globalTranslate }}</div>
                  <div class="mobile-table-data" *ngIf="row.groupNum">{{'Group Number' | globalTranslate}}: {{ row.groupNum | globalTranslate }}</div>
                  <br>
                  <div class="mobile-table-header">{{'Premium Amount' | globalTranslate }}</div>
									<hr>
									<div class="mobile-table-data" [ngClass]="{ 'column_padding': !last}">{{ row.premiumAmount | globalTranslate }}</div>
								</div>
							</div>
            </ng-container>
              <p *ngIf="!otherHealthInsuranceRows.length" class="mb-5" [innerHTML]="'RMB_OtherHealth' | globalTranslate"></p>
						</ng-container>
          </mat-expansion-panel>
        </mat-accordion>
      </div>      
      </ng-template>
      <ng-template class="slide" carouselSlide>
      <!-- Tax Information -->
      <div  id="slide4"  class="pb-4 slide-content">
        <mat-accordion displayMode="" multi class="mat-table">
          <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['taxInformation']" (expandedChange)="onExpand('taxInformation', $event)">
            <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
              <mat-panel-title>
                <div class="mat-cell-panel-header">
                  <div class="d-flex pt-3">
                    <img class="col-auto icon" aria-hidden="true" src="assets/images/Report changes/TaxInformation.svg" />
                    <div class="sub_header">
                      <span class="mat-cell title"><span class="text-danger" aria-hidden="true">*</span>{{'RMB_STARTSCREEN_TEXT_9' | globalTranslate}}<span class="sr-only"> required</span></span>
                    </div>
                  </div>
                      <br>
                      <ng-container *ngIf="expandedPanels['taxInformation']">
                        <div class="radio-buttons-container">
                          <mat-radio-group class="smallRadio" style="flex-direction: unset" (click)="toggleValue('taxInformation', $event)" formControlName="taxInformation" aria-label="Tax Information">
                            <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                            <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                          </mat-radio-group>
                         </div>
                      </ng-container>
                  <br>
                  <p class="mat-cell"
                    [ngClass]="{'panel_sub_text': expandedPanels['taxInformation'], 'pad_lt': !expandedPanels['taxInformation']}">
                    {{'RMB_STARTSCREEN_TEXT_16' | globalTranslate}}</p>
                </div>
              </mat-panel-title>
              <mat-panel-description aria-hidden="true"></mat-panel-description>
            </mat-expansion-panel-header>

            <div class="sub_content pb-4">
              <p class="sub_text" [innerHTML]="'RMB_STARTSCREEN_TEXT_29' | globalTranslate"></p>
            </div>
            <ng-container >
            <!-- Tax Filer Inside Household -->
            <p class="text-color sub_module_header pb-3"><strong>{{'RMB_TAX_INSIDE' | globalTranslate}}</strong></p>
             <div *ngIf="taxRows?.length && taxRows[0].name">
							<div *ngFor="let row of taxRows">
								<div class="table-row mb-3 pb-3 item active">
									<div class="mobile-table-header">{{'Tax Filer' | globalTranslate}}</div>
									<hr>
									<div  class="mobile-table-data">{{ row.name }}</div>
									<br>
                  <div class="mobile-table-header">{{'Filing Jointly With' | globalTranslate }}</div>
                  <hr>
									<div class="mobile-table-data">{{row.filingJointly | globalTranslate}}</div>
                  <br>
									<div class="mobile-table-header">{{'Tax Dependents' | globalTranslate }}</div>
									<hr>
                  <div class="mobile-table-data"><ul *ngIf="row.dependents?.length" class="no-bullets"><li *ngFor="let dependent of row.dependents">{{dependent.name}}</li></ul>
                    <span *ngIf="!row.dependents?.length">{{'No' | globalTranslate}}</span></div>
                  <br>
                  <div class="mobile-table-header">{{'RMB_TAX_DEDUCTIONS' | globalTranslate }}</div>
                  <hr>
                  <div class="mobile-table-data"><ul *ngIf="row.deductions?.length" class="no-bullets"><li *ngFor="let deduction of row.deductions; last as isLast">
                    <span *ngIf="deduction.type">{{deduction.type | globalTranslate}}</span><span *ngIf="deduction.amount"><br>{{deduction.amount | globalTranslate}} {{deduction.frequency | globalTranslate}}</span><span *ngIf="row.deductions.length > 1 && !isLast">,</span></li></ul>
                  <span *ngIf="!row.deductions?.length">{{'No' | globalTranslate}}</span></div>
                  <br>
                  <div class="mobile-table-header">{{'Outside Household Dependents' | globalTranslate }}</div>
                  <hr>
									<div class="mobile-table-data column_padding"><ul *ngIf="row.outOfHouseDependents?.length" class="no-bullets"><li *ngFor="let outOfHouse of row.outOfHouseDependents">
                  <span *ngIf="outOfHouse.name">{{outOfHouse.name | globalTranslate}}</span></li></ul>
                  <span *ngIf="!row.outOfHouseDependents?.length">{{'No' | globalTranslate}}</span></div>
								</div>
								<br>
							</div>
            </div>
            <p *ngIf="(taxRows?.length && !taxRows[0].name) || (!taxRows?.length)" class="mb-5" [innerHTML]="'RMB_TAX_FILER_INSIDE' | globalTranslate"></p>

            <!-- Tax Filer Ouside Household -->
            <p class="text-color sub_module_header pb-3"><strong>{{'RMB_TAX_OUTSIDE' | globalTranslate}}</strong></p>
            <div *ngIf="taxOutsideRows?.length && taxOutsideRows[0]?.outOfHouseFiler">
             <div *ngFor="let row of taxOutsideRows; let last = last" [ngClass]="{'data_container': !last}">
               <div class="table-row mb-3 pb-3 item active" [ngClass]="{'last-row': last}">
                 <div class="mobile-table-header">{{'Tax Filer' | globalTranslate}}</div>
                 <hr>
                 <div  class="mobile-table-data">{{ row.outOfHouseFiler | globalTranslate }}</div>
                 <br>
                 <div class="mobile-table-header">{{'RMB_OUTSIDE_STATIC1' | globalTranslate }}</div>
                 <hr>
                 <div class="mobile-table-data">{{row.claimedDependent | globalTranslate}}</div>
                 <br>
                 <div class="mobile-table-header">{{'RMB_OUTSIDE_STATIC2' | globalTranslate }}</div>
                 <hr>
                 <div class="mobile-table-data" [ngClass]="{ 'column_padding': !last}">{{ row.relationshipToOutsideTaxFiler | globalTranslate }}</div>
               </div>
             </div>
           </div>
           <p *ngIf="!taxOutsideRows?.length" class="mb-5" [innerHTML]="'RMB_TAX_FILER_OUTSIDE' | globalTranslate"></p>
						</ng-container>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </ng-template>
    <ng-template class="slide" carouselSlide>
    <!--------Income and employment------------------------->
    <div  id="slide5" class="pb-4 slide-content">
      <mat-accordion displayMode="" multi class="mat-table">
        <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['incomeEmployment']" (expandedChange)="onExpand('incomeEmployment', $event)">
          <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
            <mat-panel-title>
              <div class="mat-cell-panel-header">
                <div class="d-flex pt-3">
                  <img class="col-auto icon" aria-hidden="true" src="assets/images/Report changes/Income&Employment.svg" />
                <div class="sub_header">
                  <span class="mat-cell title"><span class="text-danger" aria-hidden="true">*</span>{{'RMB_STARTSCREEN_TEXT_10' | globalTranslate}}<span class="sr-only"> required</span></span>
                 
                </div>
                </div>
                <br>
                  <ng-container *ngIf="expandedPanels['incomeEmployment']">
                    <div class="radio-buttons-container">
                      <mat-radio-group class="smallRadio" style="flex-direction: unset" (click)="toggleValue('incomeEmployment', $event)" formControlName="incomeEmployment" aria-label="Income and Employment">
                        <mat-radio-button value="edit" tabindex="0">{{'EDIT_BUTTON' | globalTranslate}}</mat-radio-button>
                        <mat-radio-button value="noChange" tabindex="0">{{'NO_CHANGE_BUTTON' | globalTranslate}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </ng-container>
                <br>
                <p
                  [ngClass]="{'panel_sub_text': expandedPanels['incomeEmployment'], 'pad_lt': !expandedPanels['incomeEmployment']}">
                  {{'RMB_STARTSCREEN_TEXT_17' | globalTranslate}}</p>
              </div>
            </mat-panel-title>
            <mat-panel-description aria-hidden="true"></mat-panel-description>
          </mat-expansion-panel-header>

          <div class="sub_content pb-4">
            <p class="sub_text">
              <span [innerHTML]="'RMB_STARTSCREEN_TEXT_27' | globalTranslate"></span>
            </p>
          </div>
          <ng-container >
            <p class="text-color sub_module_header pb-3"><strong>{{'EMPLOYMENT_INCOME' | globalTranslate}}</strong></p>
            <div *ngIf="employmentIncomeRows.length" >
              <div class="table-row mb-3 pb-3 item active" *ngFor="let row of employmentIncomeRows">
                <div class="mobile-table-header">{{'Name' | globalTranslate }}</div>
                <hr>
                <div  class="mobile-table-data"> {{ row.name  }}</div>
                <br>
                <div class="mobile-table-header">{{'EMPLOYMENT_STATIC_TEXT5' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data">{{ row.employer| globalTranslate }}</div>
                <br>
                <div class="mobile-table-header">{{'Start Date' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data" *ngIf="row.startDate">{{ row.startDate | date: 'MM/dd/yyyy'  }}</div>
                <div class="mobile-table-data" *ngIf="!row.startDate">{{ 'Not Answered' | globalTranslate }}</div>
                <br>
                <div class="mobile-table-header">{{'Amount & How Often' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data">{{ row.wage | globalTranslate }} {{row.frequency | globalTranslate}}</div>
                <br>
              </div>
            </div>
            <p *ngIf="!employmentIncomeRows.length" class="mb-5" [innerHTML]="'RMB_EMPLOYMENT' | globalTranslate"></p>
            <p class="text-color sub_module_header pb-3"><strong>{{'SELF_EMPLOYMENT_INCOME' | globalTranslate}}</strong></p>
            <div *ngIf="selfEmploymentIncomeRows.length" >
              <div class="table-row mb-3 pb-3 item active" *ngFor="let row of selfEmploymentIncomeRows">
                <div class="mobile-table-header">{{'Name' | globalTranslate }}</div>
                <hr>
                <div  class="mobile-table-data"> {{ row.member  }}</div>
                <br>
                <div class="mobile-table-header">{{'Business Type' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data">{{ row.bussinessType| globalTranslate }}</div>
                <br>
                <div class="mobile-table-header">{{'Net Income' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data">{{ row.netIncome | globalTranslate }}</div>
                <br>
                <div class="mobile-table-header">{{'SELF_EMPLOYMENT_STATIC_TEXT4' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data">{{ row.bussinessName | globalTranslate }}</div>
                <br>
                <div class="mobile-table-header">{{'CO-OWENERS_HEADER1' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data column_padding"><ul *ngIf="row.coOwner?.length" class="no-bullets"><li *ngFor="let owner of row.coOwner">{{owner.namePercent}}</li></ul>
                  <span *ngIf="!row.coOwner?.length">{{'No' | globalTranslate}}</span></div>
                <br>
              </div>
            </div>
            <p *ngIf="!selfEmploymentIncomeRows.length" class="mb-5" [innerHTML]="'RMB_SELF_EMPLOYMENT' | globalTranslate"></p>
            <p class="text-color sub_module_header pb-3"><strong>{{'OTHER_INCOME' | globalTranslate}}</strong></p>
            <ng-container *ngIf="otherIncomeRows.length">
            <div *ngFor="let row of otherIncomeRows; let last = last" [ngClass]="{'data_container': !last}">
              <div class="table-row mb-3 pb-3 item active"  [ngClass]="{'last-row': last}">
                <div class="mobile-table-header">{{'Name' | globalTranslate }}</div>
                <hr>
                <div  class="mobile-table-data"> {{ row.name  }}</div>
                <br>
                <div class="mobile-table-header">{{'Income Type' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data">{{ row.incometype| globalTranslate }}</div>
                <br>
                <div class="mobile-table-header">{{'Start Date' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data" *ngIf="row.startDate">{{ row.startDate | date: 'MM/dd/yyyy' }}</div>
                <div class="mobile-table-data" *ngIf="!row.startDate">{{ 'N/A' }}</div>
                <br>
                <div class="mobile-table-header">{{'Amount & How Often' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data" [ngClass]="{ 'column_padding': !last}">{{ row.wage | globalTranslate }} {{row.frequency | globalTranslate}}</div>
                <br>
              </div>
            </div>
          </ng-container>
            <p *ngIf="!otherIncomeRows.length" class="mb-5" [innerHTML]="'RMB_OTHER_INCOME' | globalTranslate"></p>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    </ng-template>
    <ng-template class="slide" carouselSlide>
        <!-- Other Health Care -->
    <div  id="slide6" class="pb-4 slide-content">
      <mat-accordion displayMode="" multi class="mat-table">
        <mat-expansion-panel class="start-expansion-panel" [expanded]="expandedPanels['otherBenefits']" (expandedChange)="onExpand('otherBenefits', $event)">
          <mat-expansion-panel-header class="mat-row" role="region" tabindex="-1" [attr.aria-label]="null">
            <mat-panel-title>
              <div class="mat-cell-panel-header">
                <div class="d-flex pt-3">
                  <img class="col-auto icon" aria-hidden="true" src="assets/images/Report changes/OtherBenefits.svg" />
                  <div class="sub_header">
                    <span class="mat-cell title">{{'Other Health Care' | globalTranslate}}</span>
                  </div>
                </div>
                <br><br>
                <p class="mat-cell pb-4"
                  [ngClass]="{'panel_sub_text': expandedPanels['otherBenefits'], 'pad_lt': !expandedPanels['otherBenefits']}">
                  {{'RMB_STARTSCREEN_TEXT_18' | globalTranslate}}</p>
              </div>
            </mat-panel-title>
            <mat-panel-description aria-hidden="true"></mat-panel-description>
          </mat-expansion-panel-header>
          <div class="sub_content">
            <p class="sub_text">
              <span [innerHTML]="'RMB_STARTSCREEN_TEXT_31' | globalTranslate"></span>
            </p>
          </div>
          <ng-container >
            <!-- othe health Case questions -->
            <p class="text-color sub_module_header pb-3"><strong>{{'Other Health Care Questions' | globalTranslate}}</strong></p>
            <ng-container *ngIf="otherBenefitsRows.length">
            <div *ngFor="let row of otherBenefitsRows; let last = last" [ngClass]="{'data_container': !last}">
              <div class="table-row mb-3 pb-3 item active" [ngClass]="{'last-row': last}">
                <div class="mobile-table-header">{{'Assistance' | globalTranslate }}</div>
                <hr>
                <div  class="mobile-table-data"> {{ row.key | globalTranslate  }}</div>
                <br>
                <div class="mobile-table-header">{{'Response' | globalTranslate }}</div>
                <hr>
                <div class="mobile-table-data">{{ row.value | globalTranslate }}</div>
              </div>
            </div>
          </ng-container>
            <p *ngIf="!otherBenefitsRows.length" class="mb-5" [innerHTML]="'RMB_OTHER_BENEFITS' | globalTranslate"></p>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    </ng-template>
    </owl-carousel-o>
    <div class="pagination">
      {{currentSlide + 1}} of {{totalSlides}}
    </div>
    <nh-alert type="warning" [isOpen]="finalBanner">
      <div class="row">
        <div class="col-auto icon">
          <img aria-hidden="true" src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg" alt="warning" />
        </div>
        <div class="col message">
          <span [innerHTML]="'RMB_BANNER_MESSAGE_TEXT_1' | globalTranslate"></span>
          <span [innerHTML]="missingSelectionText"></span>
          <span>&nbsp;{{'RMB_BANNER_MESSAGE_TEXT_2' | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
  </div>
  </div>
</nh-form>